import { useContext } from 'react'
import slugContext from './slugContext'

const useSlug = () => {
  const { slug } = useContext(slugContext)
  return slug
}

export default useSlug
